// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing139({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/139/1.gif`}
      formFieldColor="white"
      qTitleColor="#ff4c4c"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/139/2.gif`}
      companyName="본원"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      eventDates={true}
      apiUrl={apiUrl}
    />
  );
}

export default Randing139;
